module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach3",
      "title": "Chapter 3: Let’s Get Cooking!"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch3"
    }
  }, [_vm._v("CHAPTER 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch3"
    }
  }, [_vm._v("Let’s Get Cooking!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before we dive into the recipes, here are some helpful notes on handy tools, ingredients, electric pressure cooker instructions used in the recipes, nutritional information, and alternative suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Handy Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here’s a list of a few tools that I’ve found helpful for pressure cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Flat wire steamer rack, stainless steel with wire feet:")]), _vm._v(" If it doesn’t already come with your pressure cooker, it’s a must! It keeps foods and containers out of the water and off of the hot pan when needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Heatproof ½-cup ramekins or canning jars:")]), _vm._v(" Perfect when making individual portions of cheesecake, panna cotta, and custard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Immersion or “stick” blender:")]), _vm._v(" This is great for pureeing hot soups without taking them out of the pot to blend. They range in cost, but an inexpensive one works just fine. Other popular common uses are making homemade mayonnaise, smoothies, and butter coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Japanese hot pot skimmer:")]), _vm._v(" This is a very fine mesh flat sieve that skims foams from stock with ease. In ketogenic cooking, the natural fats liberated by cooking certain grades/cuts of meat may be a little much. These natural fats are good for the ketogenic diet, but may be a little in excess to your liking. Feel free to just skim some off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Measuring cups and spoons:")]), _vm._v(" These are essential in every kitchen. It’s handy to have a couple of sets of each, one for dry and another for wet ingredients, especially if you don’t have a kitchen scale.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Kitchen scale(s):")]), _vm._v(" It takes the guesswork out of measuring volume and portion sizes. Pick a scale useful to your needs. I use one scale for larger amounts of up to 11 pounds (5kg) and another that specializes in small amounts down to 0.01g for spices and lighter foods that the larger scale can’t weigh.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Kitchen thermometer:")]), _vm._v(" Instant-read thermometers are essential in every kitchen for determining the doneness of meats accurately and safely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Sealing rings:")]), _vm._v(" Because sealing rings can sometimes pick up unwanted flavors or may become discolored over time, I suggest picking up a few extra rings and designating one for savory foods and the other for sweet. Refer to the "), _c('a', {
    attrs: {
      "href": "#/text/Chapter002#clean"
    }
  }, [_vm._v("Cleaning")]), _vm._v(" section on page 17 for more information.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Small or mini silicon mitts:")]), _vm._v(" I use these a lot. I use them to pull out the inner pot in addition to taking hot objects out of the pressure cooker. The smaller versions are easier to maneuver and pick up smaller objects without feeling clumsy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_c('b', [_vm._v("Springform pan:")]), _vm._v(" Cheesecakes are a little easier to pop out of the pan and work well for "), _c('a', {
    attrs: {
      "href": "#/text/Chapter00403#ach4-sec3"
    }
  }, [_vm._v("Mexican Taco Lasagna")]), _vm._v(" (page 29) too.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Vegetable steamer basket:")]), _vm._v(" It’s collapsible for easy storage but expandable to fit almost any pot size. Good for not only cooking cauliflower and broccoli florets in a flash, but also chicken wings.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Ingredients to Have on Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("DIY vs premade spice blends and mixes:")]), _vm._v(" I’m all for using preblended spices and spice mixes, but I was having difficulty choosing a specific brand to recommend that everyone has access to. Rather than leaving some recipes in this book a mystery by not having the specific spice blend recommendation I went old-school and mixed my own. Now you too know exactly what spices are in each recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But if you have favorite blends and mixes you gravitate to and wish to substitute with them, please do! Just approximate the total amount used in the recipe and use the same amount. (For example, if a recipe uses 3 tablespoons of total spices, use 3 tablespoons of the mix.) The exception is if the substituted blend is predominantly on the hot and spicy side. Then use it a little more sparingly, unless you like your food hot. Be sure to check the ingredient label for any sugars, starches, and fillers the premade spice mix may contain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Fats and oils:")]), _vm._v(" For some recipes, a particular oil or fat is recommended for flavor or for higher smoke point for searing, for which I often suggest avocado oil. But for the most part the oils used in these recipes are interchangeable, and you can use a substitute if you have any particular preference or dietary requirement.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Fresh versus dried herbs:")]), _vm._v(" Fresh herbs are wonderful if they are available, but that’s not always practical so it’s dried spices to the rescue! Dried spices are two to three times more concentrated than fresh. If you’re using dried spices instead of fresh and a recipe calls for 1 tablespoon of a fresh herb, use 1 teaspoon of the dried version.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Heavy cream:")]), _vm._v(" I use heavy cream (33 to 36%) whenever I can, and coconut milk with cream other times. I sometimes use them interchangeably. You could substitute with lower fat cream such as half-and-half. Just keep in mind the carb content usually increases as milk fat percentage goes down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Liquid aminos:")]), _vm._v(" Liquid aminos is a soy product that’s not fermented but is gluten free. It tastes like soy sauce but without the carbs. Tamari can also be used as a substitute, as it’s made without wheat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Sea salt versus table salt:")]), _vm._v(" I like to use sea salt of all kinds—smoked, flaked, coarse, spiced, and also pink. Not only does sea salt contain more minerals than table salt does, but it doesn’t have things like sugar, potassium iodide, and sodium thiosulfate, which are common in regular commercial table salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Stock, broth, and water:")]), _vm._v(" Homemade stock or broth is ideal. You know exactly what goes in it and you can season it to your particular liking or purpose. Commercial stocks are good too; just read the label to make sure you know what you’re getting. If you don’t have any stock or broth handy and are using water from the tap, use cool water. Hot tap water can pick up contaminants from the water heater and pipes that dissolve more readily in hot water than cold, which could affect the taste of your dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Swerve, erythritol, and other sweeteners:")]), _vm._v(" I use Swerve, which is a natural sweetener that’s a mix of erythritol and oligosaccharides that can be used as a one-to-one replacement for white sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Erythritol itself is a sugar alcohol and a natural sweetener that is naturally occurring in some fruits. For most people, erythritol isn’t fully absorbed nor retained by the body, which doesn’t affect blood glucose levels. Because it’s not retained by the body, it hasn’t been included in the nutrition value calculations. Unlike other sugar alcohols such as maltitol, which can cause stomach upset, erythritol does not have such side effects. It doesn’t have an aftertaste, but some have experienced a “cooling” sensation on the tongue.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Stevia (steviol glycosides) is a natural sweetener from the leaves of the stevia plant that is 150 times sweeter than granulated sugar. Like erythritol, it has minimal effects on blood glucose levels. It can, however, have a bitter aftertaste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Xylitol is another naturally occurring sweetener and sugar alcohol. It’s found in small amounts in fruits and vegetables. It is low on the glycemic index scale and has a minimal effect on blood glucose levels. "), _c('i', [_vm._v("It is, however, extremely harmful to dogs and can even be fatal, so use with caution.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is quite common to use a couple of alternative sweeteners in tandem to offset or counteract the aftertaste of each other, which is why you’ll see the use of two sweeteners in some of the recipes here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Xanthan gum and other thickeners:")]), _vm._v(" In a few recipes, I’ve mentioned using xanthan gum. It’s a gluten-free, low-carb thickener and emulsifier. Some sauces are nicer when they’ve got a thicker texture and have a better mouthfeel. To use xanthan gum, simply sprinkle it over your sauce and whisk it in. It thickens up pretty quickly while whisking. Keep sprinkling and whisking until you reach a desired consistency. Just be wary not to use too much, as the consistency can go “slimy.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("How to Use an Electric Pressure Cooker")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m the proud owner of two Instant Pots, the DUO60 and the Smart. I’ve also exchanged one and given another away so technically I’ve had four! I’ve been cooking with the Instant Pot for about two-and-a-half years now. Both the Instant Pots have a 6-quart capacity, and the recipes in this book were created using one or both of these workhorses. I don’t know what I’d do without them now—they’ve made cooking so much easier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These recipes can be made in any pressure cooker. Manufacturers of electric pressure cookers are different, as are their food-specific heating profiles. Rather than referencing the “POULTRY” or “SOUP” function, I’ve tried to keep it as generic as possible for all models by just referring to a “HIGH PRESSURE” setting for a specific amount of time. But cooking times may vary slightly if your pressure cooker differs in size or the pressure/heat specifications are different.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "13",
      "src": "images/line.jpg",
      "width": "683"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bx-head"
  }, [_c('b', [_vm._v("UNDERSTANDING PRESSURE")])]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_vm._v("Pressure is created in pressure cookers by boiling water in a sealed container. As the water evaporates, it fills the container with steam. The more steam generated, the higher the pressure and the higher the temperature inside the container.")]), _vm._v(" "), _c('p', {
    staticClass: "bx-txt"
  }, [_vm._v("Primarily, pressure is measured in pounds per square inch, which is abbreviated as psi. Other parts of the world use kilopascals, which is abbreviated as kPa. On some pressure cookers, one can select a high or low pressure setting. With others, one may have the versatility of 5 or 6 pressure settings to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("select from. On the electric pressure cookers, there aren’t any gauges to actually check pressure. Some older stovetop pressure cookers and pressure canners are equipped with a gauge to monitor pressure.")])]), _vm._v(" "), _c('p', {
    staticClass: "lineb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "13",
      "src": "images/line.jpg",
      "width": "683"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These are the cooking instructions (and what they mean) with reference to the pressure cooker, used in these recipes. You may not see all instructions in all recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Prepare the pot:")]), _vm._v(" This draws your attention that you should heat up the pressure cooker or add some water and put a steam rack in to get ready.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set the pressure cooker to SAUTÉ:")]), _vm._v(" The SAUTÉ, OPEN SEAR, SEAR, or BROWN function will heat up the element nice and hot for you to sauté or sear your food. (Tip: If you want to preheat the water before pressurizing, this button will do it for you.) The regular temperature the Instant Pot uses for this setting is: 275°F to 300°F (135°C to 150°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set the pressure cooker to SAUTÉ, higher setting:")]), _vm._v(" With some pressure cookers, you can increase the searing/browning temperature. When you see this instruction, just bump up the temperature on your appliance. If you don’t have this function on your cooker, not to worry—the regular temperature will still get you the results you need. The higher sauté temperature the Instant Pot uses is 350°F to 410°F (175°C to 210°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Cover with the lid and lock:")]), _vm._v(" Cover the pressure cooker and lock the lid into place, making sure it is secure. "), _c('i', [_vm._v("Make sure the sealing ring is clean and seated properly beforehand.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("SEAL the pressure release valve:")]), _vm._v(" The pressure release valve (or pressure limit valve) is a safety valve that releases or holds the steam in the pot depending on the valve’s position or orientation, whether it’s opened or closed. "), _c('i', [_vm._v("Make sure the valve isn’t blocked from the top or the underside every time you use the pressure cooker.")]), _vm._v(" Seal the pressure release valve, to seal or toggle to the closed position for pressurizing. Get ready to pressurize!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set to HIGH PRESSURE and cook for X minutes:")]), _vm._v(" Set your pressure cooker to cook at high pressure for the number of minutes indicated in the recipe. Some cookers have a default high pressure set. For the Instant Pot, high pressure is automatically set at 10.2 to 11.6 psi (70 to 80 kPa).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set to HIGH PRESSURE and cook for 0 minutes:")]), _vm._v(" This isn’t a typo! There are times when some or all of the foods in the pressure cooker can overcook really fast, such as in some vegetables, fish, and shellfish dishes. To reap the benefits of infusing flavors but not overcooking, the pressure cooker is just brought up to pressure then quickly released.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set to LOW PRESSURE and cook for X minutes:")]), _vm._v(" Set your pressure cooker to cook at a low pressure for the number of minutes indicated in the recipe. If you are lucky and can adjust the pressure, use 5.8 to 7.2 psi, which is the default low pressure on the Instant Pot. Please refer to your cooker’s manual. This setting is good for foods, such as small dice zucchini or finely shredded cabbage, that need to be cooked for a little longer but are overcooked within seconds under high pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Set to WARM:")]), _vm._v(" Set your cooker to the WARM or KEEP WARM function. This is for when you just need a little bit of heat to keep things nice and toasty!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_c('b', [_vm._v("Then QUICK RELEASE:")]), _vm._v(" After the cook time has been reached, open up the pressure release valve (or pressure limit valve) from sealing to venting to let the steam escape and bring the pressure down rapidly. For some cookers it’s also known as RAPID RELEASE. Let ’er rip! Just steer clear of the hot steam evacuating the pot. I use the pot underneath the kitchen fan and turn it on just before releasing the pressure. Keep the fan on when opening the pressure cooker lid. After unlocking the lid, lift it up slightly and tilt it away from you.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Then NATURAL RELEASE:")]), _vm._v(" After the cook time has been reached, just let the pressure cooker come down in pressure on its own. You don’t have to do a thing. Sometimes the food needs more time to cook, but in some cases where the pot is full, it needs to depressurize slowly, rather than getting “shocked” in the quick release pressure drop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("Then MANUAL RELEASE PRESSURE after X minutes:")]), _vm._v(" After the cook time has been reached, wait the number of minutes indicated before manually releasing the pressure. Some foods just need a little more time to cook or settle before releasing the pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Nutrition Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The nutritional information for each recipe has been provided as a reference guideline and is approximate for those who keep track of their individual macronutrient (fat, protein, and carbohydrate/net carbohydrate) and caloric intake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Products can differ not only from country to country but even from one producer to the next.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("If you’re counting macros strictly, I suggest that you weigh all ingredients and use the product information provided on labels to calculate the nutrition data for accuracy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The nutritional information has been compiled using Nutrifox and manually from manufacturer product labels and the United States Department of Agriculture, Agricultural Research Service, and National Nutrient Database for Standard Reference Release.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the recipes, you’ll see:")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "260",
      "src": "images/f0022-01.jpg",
      "width": "197"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Breaking it down, the nutritional information provided is per serving size. In the example, it’s per ½ cup serving size. Serving size was determined by either evenly dividing up the portions or by using 4-ounce (113g) protein "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("portions. In each recipe, serving size will be listed along with yield. Using this as a guideline, you can adjust your intake accordingly by increasing or decreasing your portion size.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Energy")]), _vm._v(" is the amount of calories per serving, which in this example is 351 calories (kcal). The conversion from the weight of the macronutrient to energy is as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1g fat = 9 calories")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1g carbohydrates = 4 calories")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1g protein = 4 calories")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Fat")]), _vm._v(" is the amount of fat contained in the serving = 26.3g")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Protein")]), _vm._v(" is the amount of protein in the serving = 21.9g")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Net Carbohydrates")]), _vm._v(" = the amount of "), _c('i', [_vm._v("total carbohydrates")]), _vm._v(" (7.7g) - "), _c('i', [_vm._v("fiber")]), _vm._v(" (2.5g) = 5.2g")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Macronutrient breakdown")]), _vm._v(" is the percentage of calories broken down into their macronutrient components. Some people use this as a guide for their macronutrient intake. Of the 351 calories, 67% of those calories are fat, 25% are protein, and 8% are total carbohydrates. I’ve kept the percentage of carbs in terms of total carbohydrates and not net carbohydrates, as I know there are some ketogenic dieters that look at total carbohydrates for their calculations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Please note that nutritional values haven’t been included for broth or stock. Short of having these tested by a lab, I haven’t been able to source a reliable and accurate way of determining the nutritional information for stock or broth. All the components used to make it (vegetables, bones with scraps of meat, etc.) are discarded, and fat may or may not be scraped off. What is left is an infusion of these elements, leaving minimal macronutrients, and I’ve seen them range from 30 to 40 calories or as much as 80 calories per cup.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Variations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where possible, alternative suggestions, variations, and different ideas were included for most recipes. These are meant to help you see the possibility in the dishes. Cooking can be creative and inspiring. The more you learn and try different things, the more likely you’ll discover new favorites and be inspired to create your own recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Recipe Icons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("While skimming through recipes, look for these symbols as a guide:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceb"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Dairy Free")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "39",
      "src": "images/f0023-01.jpg",
      "width": "38"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceb"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Peanut and Nut Free")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "38",
      "src": "images/f0023-02.jpg",
      "width": "38"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("•"), _c('span', {
    staticClass: "spaceb"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Egg Free")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "38",
      "src": "images/f0024-01.jpg",
      "width": "38"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceb"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Vegan")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "38",
      "src": "images/f0024-02.jpg",
      "width": "38"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceb"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Vegetarian")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "39",
      "src": "images/f0024-03.jpg",
      "width": "38"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7daa7f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter003.vue
// module id = 81
// module chunks = 0